module.exports = __webpack_public_path__ + "img/hamburger.b0418f64.svg";